// Part of older EBB homepage. See https://openroadmedia.atlassian.net/browse/ORMTECH-1810
import PropTypes from "prop-types";
import Image from "../Image/Image";

import styles from "./CarouselHeroCard.module.css";

const renderBookInfo = (props) => {
  if (props.showBookInfo) {
    return (
      <div className="bookInfo">
        <div className="row">
          <span className="italics">
            <span dangerouslySetInnerHTML={{ __html: props.title }} />
          </span>{" "}
          by {props.author}
        </div>
      </div>
    );
  }
  return null;
};

const CarouselHeroCard = (props) => {
  const inlineStyles = {
    background: "linear-gradient(#0000004d,#0000004d)",
    backgroundSize: "cover",
    cursor: "default",
  };
  return (
    <div
      className={[styles["CarouselHeroCard"], "CarouselHeroCard"].join(" ")}
      style={inlineStyles}
    >
      <Image
        ImageUrl={props.imageUrl}
        Alt_Text={props.alt}
        Title={props.title}
        width="100"
        height="150"
      />
      {renderBookInfo(props)}
    </div>
  );
};

export default CarouselHeroCard;

CarouselHeroCard.propTypes = {
  displayName: PropTypes.string,
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  author: PropTypes.string,
  showBookInfo: PropTypes.bool,
};
